export const clientProjects = [
    {
        id: "demo-project-alpha",
        title: "Skyline Rezidans Görselleştirme",
        status: "Devam ediyor",
        summary:
            "Skyline İş Plaza satış ofisi için 4K render seti, 60 sn walkthrough animasyonu ve peyzaj planı hazırlanıyor.",
        kickoffDate: "2025-09-12",
        deliveryDate: "2025-11-30",
        updatedAt: "2025-10-28T09:00:00Z",
        files: [
            {
                id: "demo-file-storyboard",
                label: "Storyboard v1.pdf",
                fileType: "pdf",
                note: "İlk onay turu için sunum",
                sizeLabel: "12 MB",
                storageBucket: null,
                storagePath: null,
            },
            {
                id: "demo-file-preview",
                label: "Render Önizleme 4K.mp4",
                fileType: "video",
                note: "Full HD sürüm, 4K teslimde renk düzeltmesi uygulanacak.",
                sizeLabel: "85 MB",
                storageBucket: null,
                storagePath: null,
            },
        ],
        updates: [
            {
                id: "demo-update-1",
                title: "Kickoff toplantısı tamamlandı",
                body: "Mimari kararlar, ışık senaryosu ve teslim formatları netleştirildi. Storyboard referansları paylaşıldı.",
                status: "tamamlandı",
                postedAt: "2025-09-15T10:30:00Z",
            },
            {
                id: "demo-update-2",
                title: "Storyboard onayı bekleniyor",
                body: "Storyboard v1 dosyası paylaşıldı. Onay geldiğinde animasyon bloklamasına geçilecektir.",
                status: "beklemede",
                postedAt: "2025-10-05T16:00:00Z",
            },
        ],
    },
];
